import { Component } from '@angular/core';
import { Observable, of, tap, throwError } from 'rxjs';
import { nav_path } from 'src/app/app-routing.module';
import { readStory, StoryType } from '../../../shared/interfaces/story';
import { FirestoreService } from '../../../shared/services/firestore.service';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { where } from '@angular/fire/firestore';
import { ActivatedRoute } from '@angular/router';
import { SeoService } from '../../../core/services/seo.service';
import { StoryService } from '../../../shared/services/story.service';

@Component({
  selector: 'anon-stories',
  templateUrl: './stories.component.html',
  styleUrls: ['./stories.component.scss']
})
export class StoriesComponent {
  public readonly nav_path = nav_path;
  public publicStories$?: Observable<readStory[]>;
  public error?: Error;
  private title = "Public stories page";
  public storyTypes: StoryType[] = [];
  public filterType: StoryType | 'all' = 'all';
  public filteredStories$?: Observable<readStory[]>;
  public storyTags: string[] = [];
  public filterTag?: string[];

  constructor(
    private db: FirestoreService,
    private state: TransferState,
    private route: ActivatedRoute,
    private seo: SeoService,
    private storyService: StoryService
  ) {
    seo.generateTags({
      title: this.title,
      description: `Anonymous Systems ${this.title}`,
      route: nav_path.stories
    });


    const key = makeStateKey<readStory[]>('STORIES');
    const existing = state.get(key, undefined);
    this.publicStories$ = of(existing).pipe(
      switchMap(() => this.db.colQuery$(
        `stories`,
        { idField: 'id' },
        where('visibility', '==', 'public'),
        where('status', '==', 'published')
      ) as Observable<readStory[]>),
      map(stories => this.storyService.sort(stories as readStory[], 'desc')),
      tap(stories => {
        state.set(key, stories);

        this.storyTypes = this.storyService.getStoriesTypes(stories);
        this.storyTags = this.storyService.getStoriesTags(stories);

        return stories;
      }),
      existing ? startWith(existing) : tap(),
      catchError(error => {
        this.error = error;
        return throwError(error);
      })
    );
    this.filteredStories$ = this.publicStories$;
  }
}
